import { render, staticRenderFns } from "./itemInfoBox.vue?vue&type=template&id=5f8be901&"
import script from "./itemInfoBox.vue?vue&type=script&lang=ts&"
export * from "./itemInfoBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports